module.exports = __webpack_public_path__ + "img/cloud.ff938e6d.png";